import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {AuthService} from '../services/auth.service';
import {HttpRequest, HttpHandlerFn, HttpEvent} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {UserService} from '../services/user.service';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
  const _auth = inject(AuthService);
  const token = _auth.getToken();
  const _user = inject(UserService);

  if (token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  return next(req).pipe(
    catchError((error) => {
      if (!_auth.isUserAuthenticated()) {
        _user.clearUser();
        _auth.logout();
      }
      return throwError(() => error);
    }),
  );
};
